// main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './locales/i18n';
import axios from 'axios';
import { Icon } from '@iconify/vue';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { createHead } from '@vueuse/head';
import 'flatpickr/dist/themes/dark.css';
import '@/assets/css/global.css';
import '@/assets/css/colors.css';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'slick-carousel/slick/slick-theme.css';
import initSocketListeners from './plugins/socketListeners';

import socket from './plugins/socket';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import GoogleLogin from 'vue3-google-login'; // ✅ GoogleLogin import et

// Axios ayarları
axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL;
const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common['x-auth-token'] = token;
}

async function initApp() {
  try {
    const res = await axios.get('/settings');
    const clientId = res.data.googleClientId;

    const app = createApp(App);

    app.config.globalProperties.$socket = socket;
    socket.connect();
    initSocketListeners();

    app.component('Icon', Icon);
    app.component('v-select', vSelect);

    app.use(store); // ⚠️ önce store
    app.use(router);
 
 if (store.state.auth.authToken) {
  try {
    await store.dispatch('authGetUser')
  } catch (e) {
    store.dispatch('authLogoutUser')
  }
}

    app.use(createHead());
    app.use(i18n);
    app.use(Toast, {
      position: 'top-right',
      timeout: 3000,
    });

    app.use(GoogleLogin, { clientId });

    app.mount('#app');
  } catch (err) {
    console.error('Google Client ID alınamadı:', err);
  }
}


initApp();
